import { render, staticRenderFns } from "./CreateFastData.vue?vue&type=template&id=5a4523a4&scoped=true"
import script from "./CreateFastData.vue?vue&type=script&lang=js"
export * from "./CreateFastData.vue?vue&type=script&lang=js"
import style0 from "./CreateFastData.vue?vue&type=style&index=0&id=5a4523a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4523a4",
  null
  
)

export default component.exports